import classNames from 'classnames'
import ArrowForwardIcon from 'mdi-react/ArrowForwardIcon'
import ContentCopyIcon from 'mdi-react/ContentCopyIcon'
import React from 'react'
import { Link } from 'react-router-dom'
import { makeStyles } from 'tss-react/mui'

import { Avatar, Button, Theme, Typography } from '@mui/material'

import { Corporate } from '../../../../../../../../entities-next/corporate'
import { ExtendableStyles, Testable } from '../../../../../../../../utils-next/types'
import { SCOUTING_CAMPAIGN_MANAGER_LIST_PATH } from '../../../../../ScoutingCampaignManager'
import { USER_MANAGER_LIST_PATH } from '../../../../../UsersManager'

export type UserHeaderInfoProps = ExtendableStyles &
  Testable & {
    corporate: Corporate
  }

export function CorporateHeaderInfo({ className, corporate, style, ...otherProps }: UserHeaderInfoProps) {
  const { classes } = useStyles()
  const name = corporate.name || 'New corporate'
  const handleCopy = (e: React.MouseEvent<HTMLButtonElement>) => {
    navigator.clipboard.writeText(corporate.id.toString())
    e.stopPropagation()
  }
  return (
    <div className={classNames(className, classes.container)} style={style} {...otherProps}>
      <Avatar className={classes.avatar} src={corporate.logoUrl} alt={`${name}'s profile picture`} />
      <div className={classes.userContent}>
        <Typography variant="h5">{name}</Typography>
      </div>
      <div className={classes.actionContainer}>
        <Button
          variant="contained"
          className={classes.buttonIcon}
          color="info"
          onClick={handleCopy}
          title="Copy user id"
          size="small"
        >
          <ContentCopyIcon size={16} />
          <span>Copy ID</span>
        </Button>
        <Link to={`${USER_MANAGER_LIST_PATH}?corporateId=${corporate.id}`} className={classes.noUnderline}>
          <Button variant="contained" size="small" color="info" className={classes.buttonIcon}>
            <ArrowForwardIcon size={16} />
            <span>Go to Users</span>
          </Button>
        </Link>
        <Link to={`${SCOUTING_CAMPAIGN_MANAGER_LIST_PATH}?corporateId=${corporate.id}`} className={classes.noUnderline}>
          <Button variant="contained" size="small" color="info" className={classes.buttonIcon}>
            <ArrowForwardIcon size={16} />
            <span>Go to Spaces</span>
          </Button>
        </Link>
      </div>
    </div>
  )
}

const useStyles = makeStyles()(({ spacing, palette }: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: spacing(2),
  },
  avatar: {
    width: spacing(6),
    height: spacing(6),
  },
  userContent: {
    marginLeft: spacing(2),
    flex: '1 1 auto',
  },
  extraInfo: {
    display: 'flex',
    marginTop: spacing(0.5),
  },
  extraInfoItem: {
    position: 'relative',
    marginRight: spacing(2),
    ['&:after']: {
      content: '""',
      position: 'absolute',
      left: `calc(100% + ${spacing(2)}px)`,
      marginLeft: spacing(1),
      height: '100%',
      width: 1,
      backgroundColor: palette.grey[300],
    },
    ['&:last-child:after']: {
      display: 'none',
    },
  },
  actionContainer: {
    display: 'flex',
    gap: spacing(2),
  },
  buttonIcon: {
    display: 'flex',
    gap: spacing(1),
    textDecoration: 'none',
  },
  noUnderline: {
    textDecoration: 'none',
  },
}))
